import {React} from 'react';


const GDPRHun = () => {    
 
    return (

        <div className="gdpr-wrap">
            
            <h1>Adatvédelmi Tájékoztatás</h1>
                            
            <div>
                <h2 className="important">Érintett domain:</h2>
                <p className="short-text"><a href="index.html" target="_blank">www.farkasgym.hu</a></p>
            </div>

            <div>
                <h2 className="important">Kezelt adatkör:</h2>
                <p className="short-text">SESSION</p>
            </div>

            <div>
                <h2 className="important">Süti (cookies) típusa:</h2>
                <p className="short-text">Munkamenet sütik</p>
            </div>

            <div>
                <h2 className="important">Adatkezelés jogalapja:</h2>
                <p className="long-text">A GDPR 6. cikk (1) bekezdés e) pontja, tekintettel a GDPR 24. cikkére és 32. cikkére, az állami és önkormányzati szervek elektronikus információbiztonságáról szóló 2013. évi L. törvény 5. §-ára, valamint az állami és önkormányzati szervek elektronikus információbiztonságáról szóló 2013. évi L. törvényben meghatározott technológiai biztonsági, valamint a biztonságos információs eszközökre, termékekre, továbbá a biztonsági osztályba és biztonsági szintbe sorolásra vonatkozó követelményekről szóló 41/2015. (VII. 15.) BM rendelet 3. melléklete szerint elvárt feladatokra és az Ákr. 27. § (2) bekezdésére.</p>
            </div>

            <div>
                <h2 className="important short-text">Adatkezelés célja:</h2>
                <p className="short-text">A honlap megfelelő működésének biztosítása.</p>
            </div>

            <div>
                <h2 className="important">Adatkezelés időtartama:</h2>
                <p className="short-text">A vonatkozó látogatói munkamenet lezárásáig tartó időszak.</p>
            </div>             
      
        </div>
    );
}

export default GDPRHun;